import { SidebarItem } from '../../types/navigation';
import {
  LayoutDashboard,
  Users,
  Building2,
  Briefcase,
  CheckSquare,
  BarChart3,
} from 'lucide-react';

export const baseCrmSidebarConfig: SidebarItem[] = [
  // {
  //   id: 'crm-dashboard',
  //   label: 'Dashboard',
  //   icon: <LayoutDashboard size={20} />,
  //   path: '/:orgSlug/crm/dashboard',
  // },
  {
    id: 'crm-contacts',
    label: 'Contacts',
    icon: <Users size={20} />,
    path: '/:orgSlug/crm/contacts',
  },
  {
    id: 'crm-companies',
    label: 'Companies',
    icon: <Building2 size={20} />,
    path: '/:orgSlug/crm/companies',
  },
  {
    id: 'crm-deals',
    label: 'Deals',
    icon: <Briefcase size={20} />,
    path: '/:orgSlug/crm/deals',
  },
  {
    id: 'crm-tasks',
    label: 'Task',
    icon: <CheckSquare size={20} />,
    path: '/:orgSlug/crm/tasks',
  },
  // {
  //   id: 'crm-reports',
  //   label: 'Reports',
  //   icon: <BarChart3 size={20} />,
  //   path: '/:orgSlug/crm/reports',
  // },
];
